import { FC } from 'react'
import cn from 'classnames'
import { ListRow } from 'components/extend/List'
import { PlaceholderCell } from 'components/extend/PlaceholderCell'

import { OrderTableColumnSkeletonProps } from './types'

import s from '../../OrderTable.module.less'

export const OrderTableColumnSkeleton: FC<OrderTableColumnSkeletonProps> = (props) => {
  const { isMobile, isTablet } = props
  if (isMobile) {
    return (
      <ListRow className={cn(s.item, s.skeleton)} testId="order--table--column--skeleton">
        <div className={s.column__tablet}>
          <PlaceholderCell height={20} />
        </div>
        <div className={s.column__tabletFull}>
          <PlaceholderCell height={90} />
        </div>
        <div className={s.column__tabletFull}>
          <PlaceholderCell height={30} />
        </div>
      </ListRow>
    )
  }
  if (isTablet) {
    return (
      <ListRow className={cn(s.item, s.skeleton)} testId="order--table--column--skeleton">
        <div className={s.column__tablet}>
          <PlaceholderCell height={25} />
        </div>
        <div className={s.column__tabletFull}>
          <PlaceholderCell height={210} />
        </div>
      </ListRow>
    )
  }

  return (
    <ListRow className={s.item} testId="order--table--column--skeleton">
      <div className={s.column__status}>
        <PlaceholderCell height={20} seed={3} />
      </div>
      <div className={s.column__departureTime}>
        <PlaceholderCell height={20} seed={3} />
      </div>
      <div className={s.column__transportation}>
        <PlaceholderCell height={20} seed={3} />
      </div>
      <div className={s.column__barcode_cargo}>
        <PlaceholderCell height={20} seed={3} />
      </div>
      <div className={s.column__price}>
        <PlaceholderCell height={20} />
      </div>
      <div className={s.column__cancel}>
        <PlaceholderCell height={20} />
      </div>
    </ListRow>
  )
}
